module.exports = __webpack_public_path__ + "static/calorex-header-greenfoam-dk-92ab1d6de8c12dadc00de38e720f6260.jpg";